import { render, staticRenderFns } from "./sourcearea.vue?vue&type=template&id=40390086"
import script from "./sourcearea.vue?vue&type=script&lang=js"
export * from "./sourcearea.vue?vue&type=script&lang=js"
import style0 from "./sourcearea.vue?vue&type=style&index=0&id=40390086&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40390086')) {
      api.createRecord('40390086', component.options)
    } else {
      api.reload('40390086', component.options)
    }
    module.hot.accept("./sourcearea.vue?vue&type=template&id=40390086", function () {
      api.rerender('40390086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/sourearealist/sourcearea.vue"
export default component.exports